import React from 'react';
import styles from './BackgroundMusicRow.module.css';
import {ReactComponent as TrashIcon} from '../../../assets/images/trash-icon.svg';
import {OverlayTrigger, Tooltip} from 'react-bootstrap';
import {VideoEditorText} from '../VideoEditorText';
import {music} from '../../../assets/images/';

interface Props {
  musicName?: string;
  onRemove: () => void;
  totalTimelineSeconds: number;
  pixelsPerSecond: number;
}

const removeTooltip = (
  <Tooltip>{VideoEditorText.removeBackgroundMusic}</Tooltip>
);

const BackgroundMusicRow: React.FC<Props> = ({
  musicName,
  onRemove,
  totalTimelineSeconds,
  pixelsPerSecond,
}) => {
  const barWidth = totalTimelineSeconds * pixelsPerSecond;

  return (
    <div className={styles.backgroundMusicRow} style={{width: barWidth + 30}}>
      <div className={styles.musicContainer} style={{width: barWidth}}>
        <div className={styles.musicBar}>
          <OverlayTrigger placement="top" overlay={removeTooltip}>
            <button className={styles.removeButton} onClick={onRemove}>
              <TrashIcon />
            </button>
          </OverlayTrigger>
        </div>
        <div className={styles.musicTitle}>
          <img src={music} />
          <span>{musicName || 'Background music'}</span>
        </div>
      </div>
    </div>
  );
};

export default React.memo(BackgroundMusicRow);
